angular.module('cfn').factory('bookingRules', bookingRules);

function bookingRules() {
  'use strict';
  // Private
  var elementsOrder = [
    'field',
    'fruit',
    'seed',
    'sysCulture',
    'soilSample',
    'person',
    'machine',
    'supply',
    'notes',
    'attachments',
    'incoming',
    'outgoing',
    'partner'
  ];

  var elementsOrderSupplies = [
    'field',
    'fruit',
    'supply',
    'seed',
    'sysCulture',
    'soilSample',
    'person',
    'machine',
    'notes',
    'attachments',
    'incoming',
    'outgoing',
    'partner'
  ];

  var rules = {
    elements: {
      field: {
        hideInTemplate: true
      },
      fruit: {},
      seed: {},
      supply: {},
      soilSample: {},
      sysCulture: {},
      person: {},
      machine: {},
      notes: {
        hideInTemplate: true
      },
      attachments: {
        hideInTemplate: true,
        lazyLoad: true
      },
      incoming: {
        icon: 'stockyardincoming',
        fileName: 'Stockyard'
      },
      outgoing: {
        icon: 'stockyardoutgoing',
        fileName: 'Stockyard'
      },
      partner: {}
    },
    sections: {
      FIELD: {
        activities: {
          TILLING: {
            elements: {
              field: {},
              fruit: {},
              supply: {},
              person: {},
              machine: {},
              notes: {},
              attachments: {}
            },
            activityRules: {
              isExclusive: false
            }
          },
          SOWING: {
            elements: {
              field: {},
              fruit: {
                hideInTemplate: true
              },
              seed: {},
              supply: {},
              person: {},
              machine: {},
              notes: {},
              attachments: {}
            },
            activityRules: {
              isExclusive: false
            }
          },
          SUPPLY: {
            elements: {
              field: {},
              fruit: {},
              supply: {},
              person: {},
              machine: {},
              notes: {},
              attachments: {}
            },
            activityRules: {
              isExclusive: false
            }
          },
          CULTIVATE: {
            elements: {
              field: {},
              fruit: {},
              supply: {},
              person: {},
              machine: {},
              notes: {},
              attachments: {}
            },
            activityRules: {
              isExclusive: false
            }
          },
          HARVESTING: {
            elements: {
              field: {},
              fruit: {},
              sysCulture: {},
              supply: {},
              person: {},
              machine: {},
              notes: {},
              attachments: {}
            },
            activityRules: {
              isExclusive: true
            }
          },
          SOILSAMPLE: {
            elements: {
              field: {},
              soilSample: {},
              person: {},
              machine: {},
              notes: {}
            },
            activityRules: {
              isExclusive: true
            }
          }
        }
      },
      SOILSAMPLE: {
        activities: {
          SOILSAMPLE: {
            elements: {
              field: {},
              soilSample: {},
              person: {},
              machine: {}
            },
            activityRules: {
              isExclusive: false
            }
          }
        }
      },
      STOCKYARD: {
        activities: {
          INCOMING: {
            icon: 'stockAdd',
            elements: {
              incoming: {},
              partner: {}
            },
            activityRules: {
              isExclusive: true
            }
          },
          OUTGOING: {
            icon: 'stockDel',
            elements: {
              outgoing: {},
              partner: {}
            },
            activityRules: {
              isExclusive: true
            }
          }
        }
      }
    }
  }; // ASC: seems to be that section SOILSAMPLE and STOCKYARD isn't used currently!


  for (var element in rules.elements) {
    rules.elements[element].name = element;
  }

  for (var section in rules.sections) {
    rules.sections[section].elements = {};

    for (var activity in rules.sections[section].activities) {
      rules.sections[section].activities[activity].name = activity;
      for (var element in rules.sections[section].activities[activity]
        .elements) {
        rules.sections[section].activities[activity].elements[element] =
          rules.elements[element];
        rules.sections[section].elements[element] = rules.elements[element];
      }
    }
  }

  // set status of single activity (e.g. SOWING, TILLING) to active and check if isExclusive
  var checkAndAddActiveActivity = function(section, activity) {
    if (!section || !rules.sections[section]) {
      throw new Error(
        'bookingRules.checkAndAddActiveActivity(): parameter section is invalid'
      );
    }
    var newActiveActivity = rules.sections[section].activities[activity],
      oldActiveActivities = getActiveActivities(section).filter(
        val => val.name !== activity
      ),
      newActivityIsExclusive = isExclusiveActivity(section, activity),
      oldActivitiesAreExclusive = !_.isEmpty(
        oldActiveActivities.filter(val => val.activityRules.isExclusive)
      );

    if (newActivityIsExclusive || oldActivitiesAreExclusive) {
      //CFNPOC-28498 additional exclusive rule for HARVESTING in FIELD section -> can be combined with SUPPLY
      if (section === 'FIELD') {
        if (
          newActiveActivity.name === 'HARVESTING' &&
          isActiveActivity(section, 'SUPPLY')
        ) {
          activity += ',SUPPLY';
        } else if (
          newActiveActivity.name === 'SUPPLY' &&
          isActiveActivity(section, 'HARVESTING')
        ) {
          activity += ',HARVESTING';
        }
      }
      setAllActiveActivities(section, activity);
    } else {
      buildActiveElements(section);
    }
  };

  // set status of activities (e.g. SOWING, TILLING) to active (multiple activities can be activated)
  // activities: is either a string (e.g. "SOWING, TILLING") or an activity
  var setAllActiveActivities = function(section, activities) {
    if (!section || !rules.sections[section]) {
      throw new Error(
        'bookingRules.setAllActiveActivities(): parameter section is invalid'
      );
    }
    var activitiesToActivate = {}; // HashMap for all elements to activate

    //step 0: prepare function parameters.
    if (!angular.isDefined(activities)) {
      activities = [];
    }
    if (!angular.isArray(activities)) {
      activities = activities.split(',');
    }

    //step 1: accumulate an array of elements and activities to activate...
    angular.forEach(rules.sections[section].activities, function(act, actName) {
      activities.forEach(function(activity) {
        if (act.name.toLowerCase() === activity.toLowerCase()) {
          activitiesToActivate[actName] = true;
        }
      });
    });

    //step 2: ...and activate them.
    angular.forEach(
      rules.sections[section].activities,
      (activity, activityName) => {
        activity.active = activitiesToActivate[activityName] === true;
      }
    );

    //step 3: ...activate elements.
    buildActiveElements(section);
  };

  // Elemente (FIELD,PERSON,RESOURCE)
  // einer Activity (HARVESTING, SOWING, ...)
  // für einen bestimmten Buchungssektion (section = field,stockyard,soilsample) aktivieren
  // activities = ARRAY z.B. ['HARVESTING','SUPPLY'] oder string 'HARVESTING,SUPPLY'
  var buildActiveElements = function(section) {
    if (!section || !rules.sections[section]) {
      throw new Error(
        'bookingRules.buildActiveElements(): parameter section is invalid'
      );
    }
    var elementsToActivate = {}, // HashMap for all elements to activate
      activatedActivities = _.chain(rules.sections[section].activities)
        .map(val => (val.active ? val.name : false))
        .compact(false)
        .value();

    //step 1: accumulate an array of elements to activate...
    angular.forEach(rules.sections[section].activities, function(act, actName) {
      activatedActivities.forEach(function(activity) {
        if (act.name.toLowerCase() === activity.toLowerCase()) {
          angular.forEach(act.elements, (elementToActivate, elementName) => {
            elementsToActivate[elementName] = true;
          });
        }
      });
    });

    //step 2: ...and activate them. unless explicitly turn off by default
    angular.forEach(
      rules.sections[section].elements,
      (element, elementName) => {
        element.active = elementsToActivate[elementName] === true;
      }
    );
  };

  // all active (=visible) Activities as array
  var getActiveActivities = function(section) {
    if (!section || !rules.sections[section]) {
      throw new Error(
        'bookingRules.getActiveActivities(): parameter section is invalid'
      );
    }
    return Object.keys(rules.sections[section].activities)
      .map(prop => rules.sections[section].activities[prop])
      .filter(activity => activity.active);
  };

  // returns true is activity in section is active (elements=visible)
  var isActiveActivity = function(section, activity) {
    if (!section || !rules.sections[section]) {
      throw new Error(
        'bookingRules.isActiveActivity(): parameter section is invalid'
      );
    }
    return (
      rules.sections[section].activities[activity.toUpperCase()].active === true
    );
  };

  // returns true if activity in section is exclusive
  var isExclusiveActivity = function(section, activity) {
    return (
      rules.sections[section].activities[activity.toUpperCase()].activityRules
        .isExclusive === true
    );
  };

  // get ALL elements for section as SORTED ARRAY
  var getElements = function(section, template) {
    if (!section || !rules.sections[section]) {
      throw new Error(
        'bookingRules.getElements(): parameter section is invalid'
      );
    }

    // Aussaat, Ernte, Pflege, Bodenbearbeitung
    if (template === 'SUPPLY' || template === 'PLANTPROTECTING' || template === 'TOFERTILIZE') {
      return elementsOrderSupplies
        .filter(elementName => rules.sections[section].elements[elementName])
        .map(elementName => rules.sections[section].elements[elementName]);
    } else {
      return elementsOrder
        .filter(elementName => rules.sections[section].elements[elementName])
        .map(elementName => rules.sections[section].elements[elementName]);
    }
  };

  // returns true if at least one elements is active
  var hasActiveElements = function() {
    return Object.keys(rules.elements)
      .map(prop => rules.elements[prop])
      .some(element => element.active);
  };

  // all active (=visible) elements as array
  var getActiveElements = function(section) {
    return Object.keys(rules.sections[section].elements)
      .map(prop => rules.elements[prop])
      .filter(element => element.active);
  };

  // if elementName=undefined returns true if any element is active
  // if elementName is specified returns active-state
  var isElementActive = function(section, elementName) {
    if (!section || !rules.sections[section]) {
      throw new Error(
        'bookingRules.isElementActive(): parameter section is invalid'
      );
    }
    var result = false;
    angular.forEach(rules.elements, function(element, name) {
      if (element.active) {
        if (angular.isDefined(elementName)) {
          if (elementName === name) {
            result = true;
          }
        } else {
          result = true;
        }
      }
    });
    return result;
  };

  // Public
  return {
    elementsArray: getElements,
    elements: rules.elements,

    field: rules.sections.FIELD,
    stockyard: rules.sections.STOCKYARD,
    soilsample: rules.sections.SOILSAMPLE,

    setAllActiveActivities: setAllActiveActivities,
    checkAndAddActiveActivity: checkAndAddActiveActivity,
    getActiveActivities: getActiveActivities,
    buildActiveElements: buildActiveElements,
    isActiveActivity: isActiveActivity,
    isExclusiveActivity: isActiveActivity,

    getActiveElements: getActiveElements,
    hasActiveElements: hasActiveElements,
    isElementActive: isElementActive
  };
}

export default bookingRules;
